import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-data-secure-description p-product-home--layout-vertical-offset" }
const _hoisted_2 = { class: "p-product-home--layout-offset" }
const _hoisted_3 = { class: "p-product-home--layout" }
const _hoisted_4 = { class: "p-product-home--layout-title bold black" }
const _hoisted_5 = { class: "p-product-home--layout-subtitle regular grey" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"b-data-secure-description__content row middle-xs between-xs\"><div class=\"col-xs-4 middle-xs start-xs\"><img class=\"mastercard\" src=\"/static/img/mastercard.svg\" alt=\"mastercard\"></div><div class=\"col-xs-4 middle-xs center-xs\"><img class=\"amazon\" src=\"/static/img/amazon-webservices.svg\" alt=\"Amazon web services\"></div><div class=\"col-xs-4 middle-xs end-xs\"><img class=\"pcidss\" src=\"/static/img/pcidss.svg\" alt=\"Payment Card Industry Data Security Standard\"></div></div>", 1)

import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataSecureDescriptionComponent',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("mainpage.paymentSecure.title")), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("mainpage.paymentSecure.subtitle")), 1),
        _hoisted_6
      ])
    ])
  ]))
}
}

})